import {useState} from 'react';

import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

// @ts-expect-error
import {DragHandleIcon} from 'shells/icon/svg/drag-handle-icon';

import styles from './sortable-field-item.module.css';

interface Props {
    id: string;
    disabled?: boolean;
    isActive: boolean;
    children: React.ReactNode;
}

export function SortableFieldItem(props: Props) {
    const [isHovered, setIsHovered] = useState<boolean>(false);
    const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
        id: props.id,
        disabled: props.disabled,
    });

    const style = {
        transform: isDragging ? undefined : CSS.Transform.toString(transform),
        transition: isDragging ? undefined : transition,
        opacity: isDragging ? 0 : undefined,
        pointerEvents: isDragging ? ('none' as const) : undefined,
    };

    const showHandle = isHovered || props.isActive || isDragging;

    return (
        <div
            ref={setNodeRef}
            style={style}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {showHandle ? (
                <div className={styles.row}>
                    <div {...listeners} {...attributes} className={styles['drag-handle']}>
                        <DragHandleIcon size={14} />
                    </div>
                    <div className={styles['content-hovered']}>{props.children}</div>
                </div>
            ) : (
                <div className={styles.content}>{props.children}</div>
            )}
        </div>
    );
}
